import {FormBuilder, FormGroup} from "@angular/forms";

/**
 * functions used in several config/forms.ts files
 */

export function dateRangeFormGroup(fb: FormBuilder): FormGroup{
    return fb.group({
        min: [''],
        max: [''],
    });
}